module.exports = __webpack_public_path__ + "static/media/4steps.7b23a574.svg";